import {
  ExamCenterLocationType,
  FilterOperator,
  OrderType,
  useSearchExamCenterLocationsUsageQuery,
} from '@exam-center/graphql';
import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';
import { useMemo } from 'react';

import { AdminExamCenterLocationUsageDataGrid } from '../../components';
import { useAdminExamCenterLocationUsageListSearchParams } from '../../hooks';

import { mapExamCenterLocationUsageItem } from './utils';

interface AdminExamLocationUsageListProps {
  roomId?: string;
}

export default function AdminExamLocationUsageList(
  props: Readonly<AdminExamLocationUsageListProps>,
) {
  const { roomId } = props;

  const [{ page, pageSize }, { changePageNumber, changePageSize }] =
    useAdminExamCenterLocationUsageListSearchParams();

  const { data: examLocationUsageData, loading } = useSearchExamCenterLocationsUsageQuery({
    variables: {
      searchExamCenterLocationsUsageInput: {
        filter: {
          conditions: [
            {
              field: 'refId',
              operator: FilterOperator.Equal,
              value: roomId,
            },
            {
              field: 'type',
              operator: FilterOperator.Equal,
              value: ExamCenterLocationType.Room,
            },
          ],
        },
        order: {
          field: 'examCenter.examCenterId',
          type: OrderType.Asc,
        },
        paging: {
          pageSize: pageSize,
          currentPage: page,
        },
      },
    },
  });

  const rows = useMemo(
    () =>
      examLocationUsageData?.ecSearchExamCenterLocationsUsage.examCenterLocations.map(
        mapExamCenterLocationUsageItem,
      ) ?? [],
    [examLocationUsageData],
  );

  const total = examLocationUsageData?.ecSearchExamCenterLocationsUsage.total ?? 0;

  return (
    <AdminExamCenterLocationUsageDataGrid
      loading={loading}
      hideFooter={loading || total === 0}
      rows={rows}
      slots={{
        noRowsOverlay: () => (
          <NoRowsOverlay icon={DescriptionOutlinedIcon} title='ยังไม่มีข้อมูลสิทธิ์การใช้งาน' />
        ),
      }}
      slotProps={{
        footer: {
          total,
          pagination: {
            page: page,
            count: total,
            rowsPerPage: pageSize,
            onPageChange: (_event, page) => {
              changePageNumber(page);
            },
            onRowsPerPageChange: (event) => {
              const pageSize = parseInt(event.target.value);
              changePageNumber(0);
              return changePageSize(pageSize);
            },
          },
        },
      }}
    />
  );
}
